
import { throwError as observableThrowError, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { catchError } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class DashboardCountService {
    AppUrl = '';

    constructor(private readonly _http: HttpClient) {
        this.setAPIUrl();
    }

    setAPIUrl() {
        if (sessionStorage.getItem('BaseURL') != null && sessionStorage.getItem('BaseURL') != '') {
            this.AppUrl = sessionStorage.getItem('BaseURL') || '';
        }
    }

    private handleError(error: HttpErrorResponse) {
        console.error(error.message || error);
        return observableThrowError(() => error.status);
    }

    GetAdminDashboardcount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetAdminDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetJsi360DashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetJsi360DashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetBriefingDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetBriefingDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetIPRDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetIPRDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetRMDDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetRMDDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }


    GetTracITDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetTracItDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetVoIPDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetVoIPDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetIPCSDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetIPCSDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetWirelessDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetWirelessDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    Get911DashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/Get911DashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetTRFADashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetTRFADashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetCRRADashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetCRRADashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetView47DashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetView47DashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }

    GetPriceQuoteDashboardCount(TokenKey: string): Observable<any> {
        this.setAPIUrl();
        const data = 'api/DashboardCount/GetPriceQuoteDashboardCount';
        const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', Token: TokenKey }) };
        return this._http.get<any>(this.AppUrl + data, httpOptions)
            .pipe(catchError(this.handleError));
    }
}
